import { Colors } from '@/common/colors/colors';
import Input from '@/common/components/Input';
import Loading from '@/common/components/Loading';
import PopUp from '@/common/components/PopUp';
import SelectInput from '@/common/components/SelectInput';
import Table from '@/common/components/Table';
import TextArea from '@/common/components/TextArea';
import ToggleSwitch from '@/common/components/ToggleSwitch';
import ActionButton from '@/common/components/buttons/ActionButton';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import CronInput from '@/common/components/cronInput/CronInput';
import { handleMapToOptions } from '@/common/functions/handleMapToOptions';
import styled from 'styled-components';
import PromotionsFilters from '../filters/PromotionsFilters';
import usePromotionElement from '../hooks/usePromotionElement';
import {
	ButtonSaveWrapper,
	SubTitle,
	TestingWrapper,
} from '../promotion.styles';
import PromoTemplateEdit from './PromoTemplateEdit';
import PromotionContactFilters from '../filters/PromotionContactFilters';

const TAMPLATES_HEADER = [
	'No',
	'Name',
	'SenderName',
	'SenderEamil',
	'Weight',
	'Actions',
];

const FormWrapper = styled.form`
	width: 1200px;
	height: 800px;
`;

const MAIL_PAYLOAD = {
	promoUrl: 'https://www.superpromocja.pl/',
};

const PromotionElement = ({ element, setElement, templates }) => {
	const hook = usePromotionElement({ element, setElement });

	return (
		<>
			<PopUp setShow={setElement}>
				{hook.isLoading && <Loading />}
				<FormWrapper onSubmit={hook.handleSave}>
					<h3>Promotion {element._id ? 'Edit' : 'Create'}</h3>
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
						}}
					>
						<div>
							<Input
								name='Name'
								inputRef={hook.nameRef}
								width={80}
								inputWidth={250}
								value={element.name}
								color={Colors.darkBlue}
							/>
							<SelectInput
								name='Price'
								options={hook.selectedProduct?.value?.prices?.map((p) => ({
									label: p.value,
									value: p.value,
								}))}
								selected={hook.selectedPrice}
								setSelected={hook.setSelectedPrice}
								width={80}
								selectWidth={250}
								color={Colors.darkBlue}
							/>
							<ToggleSwitch
								width={100}
								text='Active'
								toggleRef={hook.activeRef}
								checked={element.active}
							/>
							<ToggleSwitch
								width={100}
								text='One-Time Promotion'
								toggleRef={hook.isSingleUseRef}
								checked={element.isSingleUse}
							/>
							<ToggleSwitch
								width={100}
								text='Include unsubscribe'
								toggleRef={hook.includeUnsubscribeRef}
								checked={element.include_unsubscribe}
							/>
						</div>
						<div>
							<SelectInput
								name='Product'
								options={hook.productsOptions}
								selected={hook.selectedProduct}
								setSelected={hook.setSelectedProduct}
								width={120}
								selectWidth={400}
								color={Colors.darkBlue}
							/>
							<SelectInput
								name='Item'
								options={hook.itemOptions}
								selected={hook.selectedItem}
								setSelected={hook.setSelectedItem}
								width={120}
								selectWidth={400}
								missingOptionsText='Select product first...'
								color={Colors.darkBlue}
							/>
							<CronInput cron={hook.cronTime} setCron={hook.setCronTime} />
						</div>
					</div>
					<div>
						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
							}}
						>
							<SubTitle>Templates:</SubTitle>
							<ActionButton
								defaultText='Add Template'
								onClick={() => hook.setEditPromotionTemplate({})}
							/>
						</div>
						<Table
							headers={TAMPLATES_HEADER}
							raws={
								hook.promotionTemplates
									?.sort((a, b) => a.id - b.id)
									.map((t, idx) => (
										<tr key={idx}>
											<td>{t.id || '-----'}</td>
											<td>{t.name || '-----'}</td>
											<td>{t.senderName || '-----'}</td>
											<td>{t.senderEmail || '-----'}</td>
											<td>{t.weight || '-----'}</td>
											<td>
												<i
													className='fa fa-edit animation-scale'
													style={{ cursor: 'pointer' }}
													onClick={() => hook.setEditPromotionTemplate(t)}
												/>
											</td>
										</tr>
									)) || []
							}
							className='styled-table-2'
						/>
					</div>
					{hook.consultants[0] &&
						hook.markets[0] &&
						hook.products[0] &&
						hook.queues[0] && (
							<PromotionsFilters
								filters={hook.filters}
								dispatchFilters={hook.dispatchFilters}
								selectedData={hook.selected}
								setSelectedData={hook.setSelected}
								markets={handleMapToOptions(hook.markets, 'name', '_id')}
								products={handleMapToOptions(hook.products, 'name', '_id')}
								queues={handleMapToOptions(hook.queues, 'name', '_id')}
								consultants={hook.consultants}
							/>
						)}
					<PromotionContactFilters
						selectedContactFilter={hook.selectedContactFilter}
						setSelectedContactFilter={hook.setSelectedContactFilter}
					/>
					<div style={{ display: 'flex', justifyContent: 'right' }}>
						<ActionButton
							defaultText='Check query result'
							onClick={() => hook.handleCheckQuery()}
							disabled={!element._id}
						/>
					</div>
					<SubTitle>Testing: </SubTitle>
					<TestingWrapper>
						<TextArea
							textAreaRef={hook.textAreaRef}
							label='Sending object'
							placeholder='object'
							defaultValue={JSON.stringify(MAIL_PAYLOAD, null, '\t')}
							fontSize={'12px'}
							width='500px'
							minHeight='210px'
						/>
						<div>
							<Input
								showLabel={false}
								inputRef={hook.emailTestRef}
								inputWidth={350}
								name='Mail'
								type='email'
								placeholder='Type email...'
								color={Colors.darkBlue}
							/>
							<ActionButton
								defaultText='Test'
								disabled={!element._id}
								onClick={() => hook.handleTest()}
							/>
						</div>
					</TestingWrapper>
					<ButtonSaveWrapper>
						<SubmitButton text='Save' />
					</ButtonSaveWrapper>
				</FormWrapper>
			</PopUp>
			{hook.editPromotionTemplate && (
				<PromoTemplateEdit
					edit={hook.editPromotionTemplate}
					setEdit={hook.setEditPromotionTemplate}
					templates={templates}
					setTemplateConfig={hook.setPromotionTemplates}
				/>
			)}
			{hook.queryResults && (
				<PopUp setShow={hook.setQueryResults}>
					<table className='styled-table'>
						<thead>
							<tr>
								<th>No.</th>
								<th>Full name</th>
								<th>Email</th>
								<th>Market</th>
								<th>Product</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody className='queue'>
							{hook.queryResults[0] ? (
								hook.queryResults.map((result, i) => (
									<tr key={result._id}>
										<td>{i + 1}.</td>
										<td>{result.contact.full_name}</td>
										<td>{result.contact.email}</td>
										<td>{result.market.name}</td>
										<td>{result.product.name}</td>
										<td>
											<i
												className='fa fa-address-book animation-scale'
												style={{ color: Colors.darkBlue, cursor: 'pointer' }}
												onClick={() => {
													window.open(
														`/dashboard/order/${result._id}`,
														'_blank',
													);
												}}
											/>
										</td>
									</tr>
								))
							) : (
								<tr>
									<td colSpan={6}>There is no data</td>
								</tr>
							)}
						</tbody>
					</table>
				</PopUp>
			)}
		</>
	);
};

export default PromotionElement;
